import React from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks';
import styled, { css } from 'styled-components';

export const LaneStatus = () => {
  const {
    AuctionStore: { laneStatus },
  } = useStores();

  return (
    <LaneStatusContainer className="laneStatus" status={laneStatus}>
      Lane
      {' '}
      {laneStatus}
    </LaneStatusContainer>
  );
};

export default observer(LaneStatus);

export const FlexRowContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;


const getLaneStatusColor = (status) => {
  if (status === 'Ended') return { bgColor: '#DB2828', color: '#fff' };
  if (status === 'Paused') return { bgColor: '#FBCC08', color: '#000' };
  return { bgColor: '#21BA45', color: '#fff' };
};

export const LaneStatusContainer = styled(FlexRowContainer)`
  ${({ status }) => css`
    grid-area: laneStatus;
    font-size: 2em;
    font-weight: bold;
    background-color: ${getLaneStatusColor(status).bgColor};
    color: ${getLaneStatusColor(status).color};
  `};
`;
